module.exports = __webpack_public_path__ + "static/GlebGerasimenko-049921c74c97045cd6a370aff6f3988f.jpeg";